import "babel-polyfill"
import Vue from 'vue'
import App from './App.vue'
import Books from './Books.vue'
import Router from 'vue-router'
import axios from 'axios'
import store from './store'

Vue.prototype.$http = axios

Vue.use(Router)

let router = new Router({
	routes: [{
		path: '/',
		component: () => System.import('./Index.vue')
	}, {
		name: "books",
		path: '/books/:id',
		component: Books
	}, {
		name: "question",
		path: '/question/:id',
		component: () => System.import('./Question.vue')
	}]
})

new Vue({
	el: '#app',
	router,
	store,
	render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js